<template>
  <div>
    <div style="display: flex; gap: 8px; margin-bottom: 12px;">
      <el-input v-model="query.name" placeholder="合集名称" style="width: 200px" @keyup.enter="reload" />
      <el-select v-model="query.collectionType" clearable filterable placeholder="合集类型" style="width: 220px">
        <el-option v-for="o in collectionTypeOptions" :key="o.value" :label="o.label" :value="o.value" />
      </el-select>
      <el-button type="primary" :loading="loading" @click="reload">查询</el-button>
      <el-button :loading="loading" @click="openDialog()">新建合集</el-button>
    </div>

    <div style="margin-bottom: 10px;">
      <el-button
        type="primary"
        size="small"
        :loading="savingOrder"
        :disabled="!orderChanged"
        @click="saveCollectionOrder"
      >
        {{ savingOrder ? '保存中...' : '保存排序' }}
      </el-button>
      <el-button size="small" :disabled="!orderChanged" @click="resetCollectionOrder">重置</el-button>
      <span style="margin-left: 10px; color: #909399; font-size: 12px;">
        {{ sortEnabled ? '提示：拖拽左侧图标可调整合集在首页的展示顺序' : '清空筛选条件后可拖拽排序' }}
      </span>
    </div>

    <el-table v-loading="loading" :data="rows" row-key="id">
      <el-table-column width="50" label="拖拽">
        <template #default>
          <el-icon
            class="drag-handle"
            :style="{ cursor: sortEnabled ? 'move' : 'not-allowed', color: '#909399', fontSize: '16px' }"
          ><Rank /></el-icon>
        </template>
      </el-table-column>
      <el-table-column label="序号" width="72">
        <template #default="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="name" label="合集名称" min-width="160" />
      <el-table-column prop="collectionType" label="合集类型" width="160" />
      <el-table-column prop="description" label="描述" min-width="160" show-overflow-tooltip />
      <el-table-column prop="upvoteCount" label="点赞" width="72" />
      <el-table-column prop="downvoteCount" label="点踩" width="72" />
      <el-table-column label="游戏数量" width="100">
        <template #default="scope">{{ (scope.row.gameIds || []).length }}</template>
      </el-table-column>
      <el-table-column label="关联文章" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.articleId ? 'success' : 'info'">{{ scope.row.articleId ? '已关联' : '未关联' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" width="200" />
      <el-table-column label="操作" width="360" fixed="right">
        <template #default="scope">
          <el-button size="small" @click="openGamesDialog(scope.row)">管理游戏</el-button>
          <el-button size="small" type="primary" @click="openArticleDialog(scope.row)">文章</el-button>
          <el-button size="small" @click="openDialog(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="total > listLimit" style="margin-top: 12px; display: flex; justify-content: flex-end;">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :page-size="listLimit"
        :current-page="page"
        @current-change="pageChange"
      />
    </div>

    <el-dialog v-model="dialogVisible" title="合集编辑" width="520px">
      <el-form label-width="90px">
        <el-form-item label="合集名称">
          <el-input v-model="form.name" placeholder="请输入合集名称" />
        </el-form-item>
        <el-form-item label="合集类型">
          <el-select v-model="form.collectionType" filterable placeholder="请选择合集类型" style="width: 100%">
            <el-option v-for="o in collectionTypeOptions" :key="o.value" :label="o.label" :value="o.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" :rows="3" placeholder="首页卡片展示的简短描述" />
        </el-form-item>
        <el-form-item label="点赞量">
          <el-input-number v-model="form.upvoteCount" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="点踩量">
          <el-input-number v-model="form.downvoteCount" :min="0" :step="1" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="gamesDialogVisible" title="管理合集游戏" width="90%">
      <div style="display:flex; gap:8px; margin-bottom: 10px;">
        <el-select v-model="gameSearchQuery.category" clearable filterable placeholder="分类" style="width: 180px;">
          <el-option v-for="c in categoryOptions" :key="c" :label="c" :value="c"></el-option>
        </el-select>
        <el-input v-model="gameSearchQuery.title" placeholder="按游戏名称搜索" style="width: 220px" @keyup.enter="reloadCollectionGames" />
        <el-button type="primary" :loading="gameSearchLoading" @click="reloadCollectionGames">查询</el-button>
        <div style="line-height: 32px; color: #606266;">已添加 {{ gamesForm.gameIds.length }} 个</div>
      </div>

      <el-table v-loading="gameSearchLoading" :data="gameSearchRows" max-height="420">
        <el-table-column label="游戏名称" min-width="220">
          <template #default="scope">
            {{ scope.row.title || scope.row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="头像icon" width="110">
          <template #default="scope">
            <el-image
              v-if="scope.row.iconUrl || scope.row.icon"
              :src="scope.row.iconUrl || scope.row.icon"
              style="width: 32px; height: 32px; border-radius: 4px;"
              fit="cover"
            />
            <span v-else style="color:#909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="gameMd5" label="MD5" min-width="220" />
        <el-table-column label="添加到合集" width="140" fixed="right">
          <template #default="scope">
            <el-button
              size="small"
              type="primary"
              :loading="savingGames"
              :disabled="isGameAdded(scope.row.gameId)"
              @click="addGameFromRow(scope.row)"
            >
              {{ isGameAdded(scope.row.gameId) ? '已添加' : '添加' }}
            </el-button>
            <el-button
              v-if="isGameAdded(scope.row.gameId)"
              size="small"
              type="danger"
              text
              :loading="savingGames"
              @click="removeGame(scope.row.gameId)"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 12px; display: flex; justify-content: flex-end;">
        <el-pagination
          layout="prev, pager, next"
          :total="gameSearchTotal"
          :page-size="gameSearchLimit"
          :current-page="gameSearchPage"
          @current-change="collectionGamesPageChange"
        />
      </div>

      <div style="margin-top: 14px;">
        <div style="font-size: 13px; color: #606266; margin-bottom: 8px;">
          已添加游戏（{{ addedGamesMeta.length }}）
        </div>
        <div v-loading="addedGamesLoading" class="added-games-wrap">
          <div v-for="g in addedGamesMeta" :key="g.gameId" class="added-game-item">
            <el-image
              v-if="g.iconUrl || g.icon"
              :src="g.iconUrl || g.icon"
              class="added-game-icon"
              fit="cover"
            />
            <div v-else class="added-game-icon placeholder">-</div>
            <div class="added-game-name" :title="g.title || g.name || g.gameId">{{ g.title || g.name || g.gameId }}</div>
            <el-button
              size="small"
              type="danger"
              text
              :loading="savingGames"
              :disabled="!g.gameId"
              @click="removeGame(g.gameId!)"
            >
              移除
            </el-button>
          </div>
          <div v-if="!addedGamesLoading && addedGamesMeta.length === 0" style="color:#909399;">暂无已添加游戏</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-model="articleDialogVisible" title="合集文章编辑" width="70%" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="合集">
          <el-input :model-value="articleForm.collectionName" disabled />
        </el-form-item>
        <el-form-item label="文章标题">
          <el-input v-model="articleForm.title" placeholder="请输入文章标题" />
        </el-form-item>
        <el-tabs v-model="articleTab">
          <el-tab-pane name="edit" label="编辑">
            <el-input v-model="articleForm.content" type="textarea" :rows="18" placeholder="请输入 Markdown 内容" />
          </el-tab-pane>
          <el-tab-pane name="preview" label="预览">
            <div class="markdown-preview" v-html="renderMarkdown(articleForm.content)"></div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <template #footer>
        <el-button @click="articleDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingArticle" @click="saveArticle">保存文章</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Rank } from '@element-plus/icons-vue';
import { CollectionApi, CollectionArticleRow, CollectionRow } from '../../api/collectionApi';
import { Game, GameApi } from '../../api/gameApi';
import { COLLECTION_TYPE_OPTIONS } from '../../constants/collectionTypes';

let Sortable: any = null;
const loadSortable = async () => {
  try {
    const sortableModule = await import('sortablejs');
    Sortable = sortableModule.default || sortableModule;
  } catch (e) {
    console.warn('sortablejs 未安装，拖拽排序功能将不可用');
  }
};

export default defineComponent({
  name: 'Collection',
  components: {
    Rank,
  },
  data() {
    return {
      collectionTypeOptions: COLLECTION_TYPE_OPTIONS,
      loading: false,
      savingOrder: false,
      orderChanged: false,
      originalRows: [] as CollectionRow[],
      sortableInstance: null as any,
      saving: false,
      savingGames: false,
      savingArticle: false,
      rows: [] as CollectionRow[],
      total: 0,
      page: 1,
      listLimit: 500,
      query: {
        name: '',
        collectionType: '',
      },
      dialogVisible: false,
      form: {
        id: '',
        name: '',
        collectionType: '',
        description: '',
        upvoteCount: 0,
        downvoteCount: 0,
      },
      gamesDialogVisible: false,
      gamesForm: {
        id: '',
        gameIds: [] as string[],
      },
      categoryOptions: [] as string[],
      gameSearchQuery: {
        category: '',
        title: '',
      },
      gameSearchRows: [] as Game[],
      gameSearchLoading: false,
      gameSearchTotal: 0,
      gameSearchPage: 1,
      gameSearchLimit: 20,
      addedGamesLoading: false,
      addedGamesMeta: [] as Game[],
      articleDialogVisible: false,
      articleTab: 'edit',
      articleForm: {
        collectionId: '',
        collectionName: '',
        articleId: '',
        title: '',
        content: '',
      },
    };
  },
  computed: {
    sortEnabled(): boolean {
      return !this.query.name && !this.query.collectionType;
    },
  },
  methods: {
    renderMarkdown(text: string): string {
      const escaped = (text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      return escaped
        .replace(/^### (.*)$/gm, '<h3>$1</h3>')
        .replace(/^## (.*)$/gm, '<h2>$1</h2>')
        .replace(/^# (.*)$/gm, '<h1>$1</h1>')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/`([^`]+)`/g, '<code>$1</code>')
        .replace(/\n/g, '<br/>');
    },
    async init(): Promise<void> {
      this.loading = true;
      try {
        const res = await CollectionApi.list((this.page - 1) * this.listLimit, this.listLimit, this.query);
        this.rows = (res.list || []).map((row, index) => ({
          ...row,
          order: row.order ?? index + 1,
        }));
        this.total = res.total;
        this.originalRows = JSON.parse(JSON.stringify(this.rows));
        this.orderChanged = false;
        this.$nextTick(() => {
          this.initSortable();
        });
      } finally {
        this.loading = false;
      }
    },
    async initSortable(): Promise<void> {
      if (!Sortable) {
        await loadSortable();
      }
      if (!Sortable) {
        return;
      }
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
        this.sortableInstance = null;
      }
      if (!this.sortEnabled) {
        return;
      }
      const tbody = document.querySelector('.el-table__body-wrapper tbody');
      if (!tbody) {
        return;
      }
      this.sortableInstance = Sortable.create(tbody, {
        handle: '.drag-handle',
        disabled: !this.sortEnabled,
        animation: 150,
        onEnd: (evt: { oldIndex?: number; newIndex?: number }) => {
          const { oldIndex, newIndex } = evt;
          if (oldIndex === undefined || newIndex === undefined || oldIndex === newIndex) {
            return;
          }
          const movedItem = this.rows.splice(oldIndex, 1)[0];
          this.rows.splice(newIndex, 0, movedItem);
          this.rows.forEach((item, index) => {
            item.order = index + 1;
          });
          this.orderChanged = true;
        },
      });
    },
    async saveCollectionOrder(): Promise<void> {
      if (!this.sortEnabled) {
        ElMessage.warning('请先清空筛选条件后再保存排序');
        return;
      }
      this.savingOrder = true;
      try {
        const collectionOrders = this.rows.map((item, index) => ({
          id: item.id,
          order: index + 1,
        }));
        await CollectionApi.updateOrder(collectionOrders);
        this.originalRows = JSON.parse(JSON.stringify(this.rows));
        this.orderChanged = false;
        ElMessage.success('排序保存成功');
        await this.init();
      } catch (error) {
        console.error('保存排序失败:', error);
        ElMessage.error('保存排序失败，请重试');
      } finally {
        this.savingOrder = false;
      }
    },
    resetCollectionOrder(): void {
      this.rows = JSON.parse(JSON.stringify(this.originalRows));
      this.orderChanged = false;
      ElMessage.info('已重置为原始顺序');
    },
    reload(): void {
      this.page = 1;
      this.init();
    },
    pageChange(page: number): void {
      this.page = page;
      this.init();
    },
    openDialog(row?: CollectionRow): void {
      this.dialogVisible = true;
      if (!row) {
        this.form = {
          id: '',
          name: '',
          collectionType: '',
          description: '',
          upvoteCount: 0,
          downvoteCount: 0,
        };
        return;
      }
      this.form = {
        id: row.id,
        name: row.name,
        collectionType: row.collectionType,
        description: row.description || '',
        upvoteCount: row.upvoteCount ?? 0,
        downvoteCount: row.downvoteCount ?? 0,
      };
    },
    async save(): Promise<void> {
      if (!this.form.name || !this.form.collectionType) {
        ElMessage.error('请填写合集名称和类型');
        return;
      }
      this.saving = true;
      try {
        if (this.form.id) {
          await CollectionApi.update(this.form.id, {
            name: this.form.name,
            collectionType: this.form.collectionType,
            description: this.form.description,
            upvoteCount: this.form.upvoteCount,
            downvoteCount: this.form.downvoteCount,
          });
        } else {
          await CollectionApi.create({
            name: this.form.name,
            collectionType: this.form.collectionType,
            description: this.form.description,
            upvoteCount: this.form.upvoteCount,
            downvoteCount: this.form.downvoteCount,
          });
        }
        ElMessage.success('保存成功');
        this.dialogVisible = false;
        await this.init();
      } finally {
        this.saving = false;
      }
    },
    openGamesDialog(row: CollectionRow): void {
      this.gamesDialogVisible = true;
      this.gamesForm = {
        id: row.id,
        gameIds: [...(row.gameIds || [])],
      };
      this.gameSearchPage = 1;
      this.searchCollectionGames();
      this.refreshAddedGamesMeta();
    },
    async refreshAddedGamesMeta(): Promise<void> {
      const ids = [...new Set(this.gamesForm.gameIds.filter(Boolean))];
      this.addedGamesMeta = [];
      if (!ids.length) return;
      this.addedGamesLoading = true;
      try {
        const rows = await Promise.all(
          ids.map(async (gid) => {
            const res = await GameApi.getGames({ gameId: gid, skip: 0, limit: 1 } as any);
            return (res.gameList && res.gameList[0]) ? (res.gameList[0] as Game) : ({ gameId: gid } as Game);
          })
        );
        this.addedGamesMeta = rows;
      } finally {
        this.addedGamesLoading = false;
      }
    },
    async loadCategoryOptions(): Promise<void> {
      try {
        this.categoryOptions = await GameApi.getCategories();
      } catch (_e) {}
    },
    async searchCollectionGames(): Promise<void> {
      this.gameSearchLoading = true;
      try {
        const res = await GameApi.getGames({
          category: this.gameSearchQuery.category || null,
          title: this.gameSearchQuery.title || null,
          status: 'online',
          skip: (this.gameSearchPage - 1) * this.gameSearchLimit,
          limit: this.gameSearchLimit,
        } as any);
        this.gameSearchRows = (res.gameList || []).filter((g: any) => !!g.gameId);
        this.gameSearchTotal = res.total || 0;
      } finally {
        this.gameSearchLoading = false;
      }
    },
    reloadCollectionGames(): void {
      this.gameSearchPage = 1;
      this.searchCollectionGames();
    },
    collectionGamesPageChange(page: number): void {
      this.gameSearchPage = page;
      this.searchCollectionGames();
    },
    isGameAdded(gameId?: string): boolean {
      if (!gameId) return false;
      return this.gamesForm.gameIds.includes(gameId);
    },
    async addGameFromRow(row: Game): Promise<void> {
      const gameId = (row as any).gameId;
      if (!gameId) return;
      await this.addGameById(gameId);
    },
    async addGameById(gameId: string): Promise<void> {
      if (!gameId) return;
      this.savingGames = true;
      try {
        const row = await CollectionApi.addGame(this.gamesForm.id, gameId);
        this.gamesForm.gameIds = row.gameIds || [];
        await this.searchCollectionGames();
        await this.refreshAddedGamesMeta();
        await this.init();
      } finally {
        this.savingGames = false;
      }
    },
    async removeGame(gameId: string): Promise<void> {
      this.savingGames = true;
      try {
        const row = await CollectionApi.removeGame(this.gamesForm.id, gameId);
        this.gamesForm.gameIds = row.gameIds || [];
        await this.searchCollectionGames();
        await this.refreshAddedGamesMeta();
        await this.init();
      } finally {
        this.savingGames = false;
      }
    },
    async openArticleDialog(row: CollectionRow): Promise<void> {
      this.articleDialogVisible = true;
      this.articleTab = 'edit';
      this.articleForm = {
        collectionId: row.id,
        collectionName: row.name,
        articleId: '',
        title: `${row.name} 文章`,
        content: '',
      };
      const article = await CollectionApi.getArticle(row.id);
      if (article) {
        const a = article as CollectionArticleRow;
        this.articleForm.articleId = a.id;
        this.articleForm.title = a.title;
        this.articleForm.content = a.content;
      }
    },
    async saveArticle(): Promise<void> {
      if (!this.articleForm.title) {
        ElMessage.error('请填写文章标题');
        return;
      }
      this.savingArticle = true;
      try {
        await CollectionApi.saveArticle(this.articleForm.collectionId, {
          articleId: this.articleForm.articleId || undefined,
          title: this.articleForm.title,
          content: this.articleForm.content,
        });
        ElMessage.success('文章保存成功');
        this.articleDialogVisible = false;
        await this.init();
      } finally {
        this.savingArticle = false;
      }
    },
    remove(row: CollectionRow): void {
      ElMessageBox.confirm(`确认删除合集「${row.name}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await CollectionApi.remove(row.id);
        ElMessage.success('删除成功');
        await this.init();
      }).catch(() => {});
    },
  },
  async mounted() {
    await loadSortable();
    this.loadCategoryOptions();
    this.init();
  },
  beforeUnmount() {
    if (this.sortableInstance) {
      this.sortableInstance.destroy();
      this.sortableInstance = null;
    }
  },
});
</script>

<style scoped>
.markdown-preview {
  min-height: 320px;
  max-height: 60vh;
  overflow: auto;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 12px;
  background-color: #fff;
  line-height: 1.7;
}

.added-games-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px;
  min-height: 72px;
}

.added-game-item {
  width: 200px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.added-game-icon {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.added-game-icon.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.added-game-name {
  font-size: 12px;
  color: #303133;
  line-height: 1.4;
  max-width: 96px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
